module.exports = __webpack_public_path__ + "media/images/brand/favicon-07-338029bc13c330d9a3dee7bf51e38553.png";